<script lang="ts">
  import type { FavoriteStop } from '../../lib/favorites';
  import { withUniqueKeys } from '../../lib/unique-keys';

  interface Properties {
    items: FavoriteStop[];
    /** Fired when the user clicks a favorite — parent opens that stop's board. */
    onPick: (stop: FavoriteStop) => void;
  }

  const { items, onPick }: Properties = $props();

  /** Favourites keyed for `{#each}`: `extId` plus its occurrence. */
  const keyedItems = $derived(withUniqueKeys(items, (stop) => stop.extId));
</script>

<!-- Compact vertical list of starred stops. Empty state is silent (no chrome
     shown) so the panel doesn't nag the user with "no favorites yet". -->
{#if items.length > 0}
  <section class="favorites" aria-label="Favorite stops">
    <h3 class="favorites-heading">Favorites</h3>
    <ul>
      {#each keyedItems as entry (entry.key)}
        <li>
          <button
            type="button"
            class="favorite-item"
            onclick={() => {
              onPick(entry.item);
            }}>{entry.item.name}</button
          >
        </li>
      {/each}
    </ul>
  </section>
{/if}

<style>
  .favorites {
    margin-bottom: var(--space-md);
  }

  .favorites-heading {
    font-size: var(--font-size-xs);
    color: var(--color-fg-muted);
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: var(--space-xs);
  }

  ul {
    list-style: none;
    padding: 0;
  }

  .favorite-item {
    width: 100%;
    text-align: left;
    background: var(--color-surface);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-sm);
    color: var(--color-fg);
    padding: 4px 8px;
    margin-bottom: 2px;
    cursor: pointer;
    font-size: var(--font-size-sm);
  }

  .favorite-item:hover {
    border-color: var(--color-primary);
  }
</style>
